export default {
  resource: {
    zh: {
      title:"异常日志",
      rq1: "开始日期",
      rq2: "结束日期", 
      userNo: "用户编号",
      userName: "用户名",
      exUrl: "模块",
      exTime: "异常时间",
      exInfo: "异常信息",
      remark:	"备注"
    }

  },
  params: {
    userName:{
      key: "userName",
      data: null,
      method: "Contains",
      type: "text"
    },
    exUrl:{
      key: "exUrl",
      data: null,
      method: "Contains",
      type: "text"
    },
    rq1:{
      key: "exTime",
      tkey: "rq1",
      data: null,
      method: "GreaterThanOrEqual",
      type: "date"
    },
    rq2:{
      key: "exTime",
      tkey: "rq2",
      data: null,
      method: "LessThanOrEqual",
      type: "date"
    }
  },
  listDefine: [
    {key:"exTime", formatter:"fdateTime"},"exUrl","userNo","exInfo","remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  sortName: "autoid",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "exception/"

}
